import * as t from "io-ts";
import { cargoTypeT, createStopUnitTypes, nullable, unitT } from "../";
const cargoPiecesT = t.array(t.strict({
    quantity: t.number,
    unit: unitT,
}));
export const createOrderWithDetails = ({ date, decimal, isoDateTime, }) => {
    const { addStopUnitT } = createStopUnitTypes({ decimal });
    const stopT = t.intersection([
        t.strict({
            date: date,
            time: nullable(t.string),
            lm: decimal,
            colli: nullable(decimal),
            weight: nullable(decimal),
            cubicMeters: nullable(decimal),
            length: nullable(decimal),
            width: nullable(decimal),
            height: nullable(decimal),
            ref: nullable(t.string),
            tag: nullable(t.string),
            contact: nullable(t.string),
            phone: nullable(t.string),
            place: t.intersection([
                t.strict({
                    placeName: t.string,
                    address: t.string,
                    postcode: t.string,
                    city: t.string,
                    countryCode: t.string,
                    coords: t.strict({ lon: t.number, lat: t.number }),
                }),
                t.partial({
                    hereMapsId: t.string,
                }),
            ]),
            fix: nullable(t.boolean),
            cargoPieces: cargoPiecesT,
        }),
        t.partial({
            id: t.string,
        }),
    ]);
    const orderWithDetailsT = t.strict({
        cargoType: cargoTypeT,
        description: t.string,
        invoiceRef: nullable(t.string),
        minTemperature: nullable(decimal),
        maxTemperature: nullable(decimal),
        note: nullable(t.string),
        pickups: t.array(stopT),
        dropoffs: t.array(stopT),
        stopUnits: t.array(addStopUnitT),
        date: isoDateTime,
    });
    const createOrderWithDetailsAndFilesT = t.intersection([
        orderWithDetailsT,
        t.strict({
            filesReferences: t.array(t.strict({
                s3Identifier: t.string,
                name: t.string,
                mimeType: t.string,
            })),
        }),
    ]);
    return {
        orderWithDetailsT,
        createOrderWithDetailsAndFilesT,
        stopT,
    };
};
//# sourceMappingURL=order-with-details.js.map